import React, { useEffect, useState } from "react";
import Background from "../Components/Background";
import errorimg from "../assets/image/pageload.gif";
import { useNavigate } from "react-router-dom";
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
const PageNotFound = () => {
  const [loader,setloader]=useState(false)
  const navigate = useNavigate()



  useEffect(() => {

    setTimeout(() => {
      setloader(true)
    }, 5000);
    setTimeout(() => {
     navigate('/')
    }, 7000);
   
  }, [])
  
  return (
    <div>
      <div className="flex flex-col justify-center relative items-center z-40 w-screen h-screen ">
     
      {
        loader ? <><div className="h-screen w-screen flex flex-row justify-center items-center">
        <img src={errorimg} className="z-40 relative " alt="snap"/>
    </div></> :<div className="flex flex-col text-white text-6xl justify-center relative items-center z-40 w-screen h-screen"> 
     <CountdownCircleTimer
        isPlaying
        size={120}
        duration={5}
  
        colors={['#F7B860', '#F7B801',  '#A30000']}
        colorsTime={[ 5, 2, 0]}
      >
        {({ remainingTime }) => remainingTime}
      </CountdownCircleTimer> <div className="z-50 text-slate-200 font-extrabold text-8xl hover:text-yellow-400">
          404
        </div>
      <div className="flex flex-row w-full md:w-3/6 p-4">
      <div className="flex items-center font-bold text-center text-xl justify-center z-50 text-slate-100  uppercase newfont">
          Sorry, either you mistyped the url or we deleted that page, but let's
          agree to blame this on you.
        </div>
      
      </div> </div>
      }
       
      </div>

      <Background />
    </div>
  );
};

export default PageNotFound;
